export const LOADING_DIALOG_OPTIONS = { width: "192px", height: "192px", disableClose: true };
export const LIST_AMOUNT_PER_PAGE = 10;
export const SITE_HOSTNAME = "www.syrzdarma.cz";

// 5 minutes in milliseconds
export const LOCAL_FORAGE_CACHE_DURATION = 1000 * 60 * 5;
